/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { Row, Col,  Table, Spin, message, Tag, Space, Tooltip, DatePicker, Select, Typography, Modal, Button, Popover, Avatar, Card} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useEffect, useReducer, useState } from 'react';
import axios from 'axios';
import reducer from './reducer';
import { SCHEDULE_LIST_SUCCESS, SCHEDULE_LIST_ERROR, SCHEDULE_LIST, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR} from './constants';
import { useNavigate } from 'react-router-dom';
import malayalamlan from '../../../malayalam.json';
import { useAuth } from '../../Context';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import dayjs from 'dayjs';

import Title from 'antd/es/typography/Title';
import { CalendarOutlined, DownloadOutlined, InfoOutlined } from '@ant-design/icons';
import moment from 'moment';
import { BatchDownloader } from './downloader';
let schedule_data_pagination = {};


export default function ScheduleList() {
    
	const initalState = { pending: false, error: false, schedule : [],users_data:[], pagination: { total: 0, limit: 10, skip: 0, current:1 },details : null};
	const [data, dispatch] = useReducer(reducer, initalState);
	const navigate = useNavigate();
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);

	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const [startDate, setStartDate] = useState(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	// const [usertypeId, setUserTypeId] = useState(null);
	const [user, setUser] = useState(null);
	const [showFetchAndDownloadModal, setShowFetchAndDownloadModal] = useState(false);

	const [url,setURL] = useState();


	const openShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(true);
	};

	const closeShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(false);
	};



	const { RangePicker } = DatePicker;

	useAuth();

	useEffect(() => {
		// if(featuresModule == false) {
		// 	navigate('/dashboard');
		// }
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4014);
	}, []);
    
    
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		loadSchedule(1);
		usersList();
        
	},[authtoken, startDate, endDate,user]);
    
	
	
    
	const loadSchedule = (pagination) => {
		let _pagination = { };
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;
    
		dispatch({ type : SCHEDULE_LIST});		
		let userParams = '';
		if(user){
			userParams =`&$and[0][userId]=${user}`;
		}
		else{
			userParams = '';
		}

		setURL({base: `${api}/loginschedulemanagement-list`,params:`pipelineId=${parseInt(pipelineId)}${userParams}&datetimeFrom[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&datetimeFrom[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}`});
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/loginschedulemanagement-list?$sort[id]=-1&$limit=${_pagination.limit}&$skip=${_pagination.skip}&pipelineId=${parseInt(pipelineId)}&datetimeFrom[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&datetimeFrom[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}${userParams}`,
			timeout: timeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`
			}
		};
    
		axios.request(config)
			.then((response) => {

				schedule_data_pagination.total = response.data.total ? response.data.total : 0;
				schedule_data_pagination.limit = response.data.limit ? response.data.limit : 10;
				schedule_data_pagination.skip = response.data.skip ? response.data.skip : 0;
				schedule_data_pagination.current = pagination.current ? pagination.current : 1;
                
				
				if ( response.status === 200) { 
					dispatch({ type : SCHEDULE_LIST_SUCCESS, payload : response.data, page:pagination.current, pageSize : pagination.pageSize });
                        
				} else { 
					dispatch({ type : SCHEDULE_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : SCHEDULE_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const usersList = () => {

		dispatch({ type : USERS_LIST});

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation-list?&isDeleted=false&usertypeId[$in][]=4&usertypeId[$in][]=7&usertypeId[$in][]=13`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
      
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : USERS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : USERS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};
    
	
    
	
        

        
    
	const columns = [
		{
			title : langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex : 'name',
			key : 'name'
		},
		{
			title : langdata && langdata.Username ? langdata.Username : 'User name',
			dataIndex : 'userName',
			key : 'userName'
		},
		{
			title : langdata && langdata.TimeFrom ? langdata.TimeFrom : 'Time From',
			dataIndex : 'datetimeFrom',
			key : 'datetimeFrom'
		},
		{
			title : langdata && langdata.TimeTo ? langdata.TimeTo : 'Time To',
			dataIndex : 'datetimeTo',
			key : 'datetimeTo'
		},
		{
			title :  langdata && langdata.LatestSchedule ? langdata.LatestSchedule : 'Latest Schedule',
			dataIndex : 'latestSchedule',
			key : 'latestSchedule',
			render: (_, { latestSchedule }) => (
				<>
					<Tag
						color={
							latestSchedule ? 'green' : 'red'
						}
					>
						{latestSchedule ? langdata && langdata.Yes ? langdata.Yes : 'Yes' : langdata && langdata.No ? langdata.No : 'No' }
					</Tag>
				</>
			),
		}, 
	];



	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}else{
					
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}
		} else {
			console.log('Clear');
		}
	};

	
	
	

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	let users=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];
	
	data.users_data && data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});

	const handleSetUser = (e) =>{
		setUser(e);
	};

	

	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};


	const getDateWithTime = (date, time) => {
		if (!time) return date;

		const [hour, minute, second] = time.split(':').map(Number);

		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.scheduleInfoContent ? langdata.scheduleInfoContent :'This section provides an overview of users with schedule-enabled access, including their permitted access periods and configured time windows.'}</p>
		</Card>
	);


	
	return (
		<>
			<Content>
				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
					justify={'space-between'}
				>
	
	
					<Col>
						<Row>
						
							<Space>
								<CalendarOutlined style={{fontSize:'30px'}} />
								
							</Space>
						
							<Space>&nbsp;&nbsp;</Space>
											
											
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.Schedule?langdata.Schedule:'Schedule'}</Title>
						</Row>

					</Col>
					<Col style ={{display:'flex',justifyContent:'flex-end'}}  span={14} >
						<Row style ={{display:'flex',justifyContent:'flex-end',}}>
							<Col span={24} style={{display:'flex',flexWrap:'wrap',justifyContent:'flex-end', gap:'8px',maxWidth:'920px',paddingRight:'10px'}}>

								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.FilterbyUser ? langdata.FilterbyUser :'Filter by User'}>
									
										<Space>
											<Select Item
												style={{ minWidth: '200px', margin:'5px'}}
												showSearch
												filterOption={filterOption}
												placeholder={langdata && langdata.SelectUsers ? langdata.SelectUsers :'Select Users'}
												optionFilterProp="children"
												// onChange={onChange}
												// onSearch={onSearch}
												// filterOption={filterOption}
												defaultValue={null}
												options={users}
												onSelect={handleSetUser}
									
											/>  
										</Space>
									</Tooltip>  
								</Space>
								
								<Space>
										
									<Tooltip title={langdata?.Selectdate || 'Select date'}>
										<RangePicker
											style={{margin:'5px'}}
											onChange={onRangeChange}
											disabledDate={disabledDate}
											allowClear={false}
											showTime
											format={`${settingsdateformat} ${settingstimeformat}`}
											defaultValue={[
												getDateWithTime(dayjs().subtract(30, 'day'), customstart),
												getDateWithTime(dayjs(), customend)
											]}
										/>
									</Tooltip>
								</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.Schedule ? langdata.Schedule:'Schedule'}  content={infoContent} trigger="click">
											<Avatar size="small" style={{marginTop:'5px',marginBottom:'5px'}}><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
					{/* </Space> */}
				</Row>

				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						<Table 
							scroll={{
								x: 900,
							}}
							columns={columns} dataSource={data.schedule} pagination = { data.schedule.length > 0 ? data.pagination : 0 } onChange={loadSchedule}
							onRow = {() => {
								return {
									onClick: () => { 
										// loadScheduleDetails(record);
                                        
                                                
									}
								};
							}}
						/>
					</Col>
				</Row>

				<Row gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
				style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
					justifyContent:'center',
					display:'flex'
				}} 
				>
					<Col style={{
						alignItems:'left',
						justifyContent:'left',
						display:'flex',
						padding:'10px'
					}}  className="gutter-row" span={24}>
						<Button disabled={data.schedule && data.schedule.length > 0 ? false : true} type="primary" title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'} onClick={openShowFetchAndDownloadModal}><DownloadOutlined />{langdata && langdata.Download ? langdata.Download:'Download'}</Button>
					</Col>

				</Row>

				<Spin fullscreen spinning={data.pending} />
			</Content>


			<Modal
				title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'}
				centered
				destroyOnClose={true}
				open={showFetchAndDownloadModal}
				onOk={{closeShowFetchAndDownloadModal}}
				onCancel={closeShowFetchAndDownloadModal}
				footer={[
					
				]}
				width={540}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Typography>
							{langdata && langdata.Totalnumberofrecords ? langdata.Totalnumberofrecords:'Total number of records'} : {schedule_data_pagination.total}
						</Typography>
					</Col>
				</Row>

				{schedule_data_pagination && schedule_data_pagination.total> 0 ? (
					<BatchDownloader total={schedule_data_pagination && schedule_data_pagination.total} url={url}/>
				) : (
					<>
						<Row gutter={16} style={{
							backgroundColor: '#d3d3d3',
							padding: '5px',
							marginTop: '10px'
						}}>
							<Col span={24}>
								<Typography>{langdata && langdata.Norecordsfound ? langdata.Norecordsfound:'No records found.'}</Typography>
							</Col>
						</Row>
						<br/>
					</>
          
				)}
			</Modal>
		</>
	);
}

